var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPractitionersIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58325 10.5C11.6543 10.5 13.3333 8.82107 13.3333 6.75C13.3333 4.67893 11.6543 3 9.58325 3C7.51218 3 5.83325 4.67893 5.83325 6.75C5.83325 8.82107 7.51218 10.5 9.58325 10.5Z",
    fill: "#A9A9A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58333 12.5825C6.80208 12.5825 1.25 13.8853 1.25 16.4714V18.4159H17.9167V16.4714C17.9167 13.8853 12.3646 12.5825 9.58333 12.5825Z",
    fill: "#A9A9A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPractitionersIcon);
export default __webpack_public_path__ + "static/media/practitioners-icon.4d6ef6e0b97e2c3b9de480bc7f8148f2.svg";
export { ForwardRef as ReactComponent };